import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { ApiService } from '../services/api.service';
import { catchError, NEVER } from 'rxjs';
import { LoginResponse } from '../constants/constants';
import { NotificationService } from '../services/notification.service';

@Component({
    selector: 'app-login',
    imports: [MatCardModule, MatIconModule,
        MatButtonModule, FormsModule, MatInputModule],
    templateUrl: './login.component.html',
    styleUrl: './login.component.scss'
})
export class LoginComponent {
  username: string;
  password: string;

  constructor(private apiService:ApiService, private toastr: NotificationService){}

  login(){
    this.apiService.login(this.username, this.password).pipe(catchError(err=>{
      this.toastr.error(err?.error?.message || 'Something went wrong, please check internet connection', "Login Failed");
      console.error('error received from api: ',err?.error?.message);
    return NEVER})).subscribe((resp:LoginResponse)=>
      this.apiService.manualLogin(resp))
  }

}
